/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AuthGuard } from '../../../../../core/guards';
import {
    DomainValidationDirective,
    HostnameValidationDirective,
    IntegerValidationDirective,
    IPValidatorDirective,
    NameValidationDirective
} from '../../../../../core/directives';
import {
    FloatingIPsResolver,
    FrontendsResolver,
    GslbWizardService,
    HangingBackendsModalComponent,
    HangingRealServersModalComponent,
    HaProxyTimeValidationDirective,
    HealthChecksApiService,
    L7HeadersTextareaValidationDirective,
    Layer47SaveService,
    Layer47SubmissionService,
    Layer47WizardService,
    Layer4BackendComponent,
    Layer4FrontendComponent,
    Layer4RealComponent,
    Layer7BackendComponent,
    Layer7FrontendComponent,
    LbErrorService,
    LockApiService,
    MultipleFloatingIpsModalComponent,
    SaveModalComponent,
    ServicesMonitorComponent,
    SSLCiphersApiService,
    WizardNavigationService,
    WizardSaveService,
    WizardSubmissionService,
    WizardTemplateService
} from '../../../shared';
import { GslbSubmissionService } from '../../../shared/services/components/wizard/gslb.wizard.submission.service';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { ManageServicesComponent } from './manageServices.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        LoadbalancerSharedModule,
        RouterModule
    ],
    declarations: [
        DomainValidationDirective,
        HaProxyTimeValidationDirective,
        HangingBackendsModalComponent,
        HangingRealServersModalComponent,
        HostnameValidationDirective,
        IPValidatorDirective,
        IntegerValidationDirective,
        L7HeadersTextareaValidationDirective,
        Layer4BackendComponent,
        Layer4FrontendComponent,
        Layer4RealComponent,
        Layer7BackendComponent,
        Layer7FrontendComponent,
        ManageServicesComponent,
        MultipleFloatingIpsModalComponent,
        NameValidationDirective,
        SaveModalComponent,
        ServicesMonitorComponent
    ],
    providers: [
        AuthGuard,
        FloatingIPsResolver,
        FrontendsResolver,
        GslbSubmissionService,
        GslbWizardService,
        HealthChecksApiService,
        Layer47SaveService,
        Layer47SubmissionService,
        Layer47WizardService,
        LbErrorService,
        LockApiService,
        SSLCiphersApiService,
        WizardNavigationService,
        WizardSaveService,
        WizardSubmissionService,
        WizardTemplateService
    ],
    exports: [
        L7HeadersTextareaValidationDirective
    ]
})

export class ManageServicesModule {
}
